define('helpers/contact-mixin',[
    'evertrue',
    'jquery',
    'underscore'
], function(EverTrue, $, _){

    var ContactHelper = function() {
        var self = this;

        self.getSchema = function(roles) {
            return {
                fieldset: [{
                    formElements : [
                        {
                            type: "text",
                            label: "First Name",
                            key : "name_first",
                            parsley: "data-required=true"
                        },
                        {
                            type: "text",
                            label: "Nickname",
                            key : "name_nick"
                        },
                        {
                            type: "text",
                            label: "Middle Name",
                            key : "name_middle"
                        },
                        {
                            type: "text",
                            label: "Last Name",
                            key : "name_last",
                            parsley: "data-required=true"
                        },
                        {
                            type: "text",
                            label: "Maiden Name",
                            key : "name_maiden"
                        },
                        {
                            type: "text",
                            label: "Suffix",
                            key : "name_suffix"
                        },
                        {
                            type: "text",
                            label: "Year",
                            key : "year"
                        },
                        {
                            type: "checkbox",
                            label: "Role",
                            key : "role",
                            parsley: "data-required=true",
                            checkboxes: roles
                        },
                        {
                            type: "text",
                            label: "Primary Email",
                            key : "identity_email",
                            parsley: "data-required=true"
                        },
                        {
                            type: "select",
                            label: "Status",
                            key : "status",
                            suppression_field : true,
                            select : [
                                {
                                    val : false,
                                    val_display: "Visible"
                                },
                                {
                                    val : true,
                                    val_display: "Hidden"
                                }
                            ]
                        }
                    ]
                }]
            };
        };

        self.setBasicTemplate = function(model) {
            properties = model.properties;
            identities = model.identities;
            tmplData = {};
            // setup "general info"
            tmplData.id                = model.id;
            tmplData.remote_id         = _.findWhere(identities, {"type": "remote_id"}) ? _.findWhere(identities, {"type": "remote_id"}).value : "";
            tmplData.roles             = model.roles_override ? model.roles_override : model. roles;
            tmplData.status            = model.private;
            tmplData.privatized_source = model.privatized_source;
            tmplData.name_first        = EverTrue.findInArray("name_first", properties);
            tmplData.name_last         = EverTrue.findInArray("name_last", properties);
            tmplData.name_nick         = EverTrue.findInArray("name_nick", properties);
            tmplData.name_maiden       = EverTrue.findInArray("name_maiden", properties);
            tmplData.name_middle       = EverTrue.findInArray("name_middle", properties);
            tmplData.name_suffix       = EverTrue.findInArray("name_suffix", properties);
            tmplData.name_display      = tmplData.name_first + " " + tmplData.name_last;
            tmplData.title_name        = tmplData.name_display;
            tmplData.year              = EverTrue.findInArray("year", properties);
            tmplData.deceased          = EverTrue.findInArray("deceased", properties);
            tmplData.identity_email    = "hide_on_edit";
            tmplData.matched           = model.matched;
            return tmplData;
        };

        self.setContactObj = function(key, obj) {
            var profileObj = {};
            switch (key) {
                // Evertrue.findInArray relies on having a property object[name] = param1
                // If this value can't be found it will return an empty string, which may be an incorrect value
                // this can cause issues with importer, if certain values are imported
                case "phones":
                    profileObj["status"]            = (_.first(obj.properties)) ? _.first(obj.properties)['private'] : "";
                    profileObj["privatized_source"] = (_.first(obj.properties)) ? _.first(obj.properties)['privatized_source'] : "";
                    profileObj["phone"]             = EverTrue.findInArray("phone", obj.properties);
                    profileObj["type"]              = EverTrue.findInArray("type", obj.properties);
                    profileObj["primary"]           = EverTrue.findInArray("primary", obj.properties);
                    profileObj["do_not_contact"]    = EverTrue.findInArray("do_not_contact", obj.properties);
                    break;
                case "emails":
                    profileObj["status"]            = (_.first(obj.properties)) ? _.first(obj.properties)['private'] : "";
                    profileObj["privatized_source"] = (_.first(obj.properties)) ? _.first(obj.properties)['privatized_source'] : "";
                    profileObj["email"]             = EverTrue.findInArray("email", obj.properties);
                    profileObj["type"]              = EverTrue.findInArray("type", obj.properties);
                    profileObj["primary"]           = EverTrue.findInArray("primary", obj.properties);
                    profileObj["do_not_contact"]    = EverTrue.findInArray("do_not_contact", obj.properties);
                    break;
                case "addresses":
                    profileObj["status"]            = (_.first(obj.properties)) ? _.first(obj.properties)['private'] : "";
                    profileObj["privatized_source"] = (_.first(obj.properties)) ? _.first(obj.properties)['privatized_source'] : "";
                    profileObj["address_1"]         = EverTrue.findInArray("address_1", obj.properties);
                    profileObj["address_2"]         = EverTrue.findInArray("address_2", obj.properties);
                    profileObj["address_3"]         = EverTrue.findInArray("address_3", obj.properties);
                    profileObj["city"]              = EverTrue.findInArray("city", obj.properties);
                    profileObj["state"]             = EverTrue.findInArray("state", obj.properties);
                    profileObj["zip_code"]          = EverTrue.findInArray("zip_code", obj.properties);
                    profileObj["country"]           = EverTrue.findInArray("country", obj.properties);
                    profileObj["type"]              = EverTrue.findInArray("type", obj.properties);
                    profileObj["primary"]           = EverTrue.findInArray("primary", obj.properties);
                    break;
                case "employments":
                    profileObj["status"]            = (_.first(obj.properties)) ? _.first(obj.properties)['private'] : "";
                    profileObj["privatized_source"] = (_.first(obj.properties)) ? _.first(obj.properties)['privatized_source'] : "";
                    profileObj["company"]           = EverTrue.findInArray("company", obj.properties);
                    profileObj["title"]             = EverTrue.findInArray("title", obj.properties);
                    profileObj["industry"]          = EverTrue.findInArray("industry", obj.properties);
                    break;
                case "educations":
                    profileObj["status"]            = (_.first(obj.properties)) ? _.first(obj.properties)['private'] : "";
                    profileObj["privatized_source"] = (_.first(obj.properties)) ? _.first(obj.properties)['privatized_source'] : "";
                    profileObj["school_name"]       = EverTrue.findInArray("school_name", obj.properties);
                    profileObj["year"]              = EverTrue.findInArray("year", obj.properties);
                    profileObj["degree_key"]        = EverTrue.findInArray("degree_key", obj.properties);
                    profileObj["majors"]            = EverTrue.findInArray("majors", obj.properties);
                    break;
                default:
                    custom_name = _.first(obj.properties) ? _.first(obj.properties).name : "";
                    custom_value = _.first(obj.properties) ? _.first(obj.properties).value : "";
                    if (custom_name && custom_value) {
                        profileObj["name"] = custom_name;
                        profileObj["value"] = custom_value;
                        profileObj["is_custom"] = true;
                    }
            }
            return profileObj;
        };

    };

    return new ContactHelper();
});

